import { selectStatus } from 'services/store/utils-selectors';
import { statusTypes } from '../definitions';

const selectTodoStatus = (state, action, ...parameters) => (
  selectStatus(state, 'todos', statusTypes[action] || action, parameters) || {}
);

export default selectTodoStatus;
